import { createSimpleCRUDEntity } from '../crud-factory';

// Provider Entity (simple, no transformations)
export const Provider = createSimpleCRUDEntity('providers');
